module.exports = __webpack_public_path__ + "img/denmark-logo-icon.4adc18af.png";